import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { CreateSobreavisoSchema, Sobreaviso, sobreaviso } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function AdicionarSobreaviso() {
    const { mutateAsync, isLoading } = sobreaviso.mutations.useCreate({
        invalidateQuery: true,
    })
    const [empresaId, funcionarioId] = [
        useStore(state => state.companyId),
        useStore(state => state.employeeId),
    ]

    const handleSubmit: SubmitHandler<Sobreaviso> = async data =>
        mutateAsync(
            { ...data, funcionarioId, empresaId },
            {
                onSuccess: () => {
                    toast.success('Sobreaviso adicionado com sucesso')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateSobreavisoSchema}
            open={hasPermission(['create', 'Sobreaviso'])}
        >
            <Dialog.Title>Adicionar Sobreaviso</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SelectEmpresa width="100%" />
                    </Grid>
                    <Grid item xs={12}>
                        <SelectFuncionario ativos width="100%" />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="data"
                            type="date"
                            label="Data"
                            required
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="horarioInicial"
                            type="time"
                            label="Hora Inicial"
                            required
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormField
                            name="horarioFinal"
                            type="time"
                            label="Hora Final"
                            required
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
